export const uk = {
    newAudience: 'Новая аудитория',
    newGroup: 'Новая группа'
};
